import API from "../../utils/endpoints";
import * as types from "./actionType";
import history from "../../history";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const errorMessage = {
	status: 400,
	message: "Something went wrong",
};

function fetchingAllEvents() {
	return {
		type: types.FETCH_ALL_EVENT,
	};
}

function fetchingAllEventsSuccess(payload) {
	return {
		type: types.FETCH_ALL_EVENT_SUCCESS,
		payload,
	};
}

function fetchingAllEventsFailed() {
	return {
		type: types.FETCH_ALL_EVENT_FAILED,
	};
}

function fetchingSingleEvent() {
	return {
		type: types.FETCH_SINGLE_EVENT,
	};
}

function fetchingSingleEventSuccess(payload) {
	return {
		type: types.FETCH_SINGLE_EVENT_SUCCESS,
		payload,
	};
}

function fetchingSingleEventFailed() {
	return {
		type: types.FETCH_SINGLE_EVENT_FAILED,
	};
}

function fetchingCountry() {
	return {
		type: types.FETCH_COUNTRY,
	};
}

function fetchingCountrySuccess(payload) {
	return {
		type: types.FETCH_COUNTRY_SUCCESS,
		payload,
	};
}

function fetchingCountryFailed() {
	return {
		type: types.FETCH_COUNTRY_FAILED,
	};
}

function fetchingState() {
	return {
		type: types.FETCH_STATE,
	};
}

function fetchingStateSuccess(payload) {
	return {
		type: types.FETCH_STATE_SUCCESS,
		payload,
	};
}

function fetchingStateFailed() {
	return {
		type: types.FETCH_STATE_FAILED,
	};
}

function fetchingCity() {
	return {
		type: types.FETCH_CITY,
	};
}

function fetchingCitySuccess(payload) {
	return {
		type: types.FETCH_CITY_SUCCESS,
		payload,
	};
}

function fetchingCityFailed() {
	return {
		type: types.FETCH_CITY_FAILED,
	};
}

function creatingEvent() {
	return {
		type: types.CREATE_EVENT,
	};
}

function creatingEventSuccess(payload) {
	return {
		type: types.CREATE_EVENT_SUCCESS,
		payload,
	};
}

function creatingEventFailed() {
	return {
		type: types.CREATE_EVENT_FAILED,
	};
}

function updatingEvent() {
	return {
		type: types.UPDATE_EVENT,
	};
}

function updatingEventSuccess(payload) {
	return {
		type: types.UPDATE_EVENT_SUCCESS,
		payload,
	};
}

function updatingEventFailed() {
	return {
		type: types.UPDATE_EVENT_FAILED,
	};
}

function deletingEvent() {
	return {
		type: types.DELETE_EVENT,
	};
}

function deletingEventSuccess(payload) {
	return {
		type: types.DELETE_EVENT_SUCCESS,
		payload,
	};
}

function deletingEventFailed() {
	return {
		type: types.DELETE_EVENT_FAILED,
	};
}

function moderatingEvent() {
	return {
		type: types.MODERATION_OF_EVENT,
	};
}

function moderatingEventSuccess(payload) {
	return {
		type: types.MODERATION_OF_EVENT_SUCCESS,
		payload,
	};
}

function moderatingEventFailed() {
	return {
		type: types.MODERATION_OF_EVENT_FAILED,
	};
}

function moderatingEventGallery() {
	return {
		type: types.MODERATION_OF_EVENT_GALLERY,
	};
}

function moderatingEventGallerySuccess(payload) {
	return {
		type: types.MODERATION_OF_EVENT_GALLERY_SUCCESS,
		payload,
	};
}

function moderatingEventGalleryFailed() {
	return {
		type: types.MODERATION_OF_EVENT_GALLERY_FAILED,
	};
}

function fetchingEventForModeration() {
	return {
		type: types.FETCH_EVENT_FOR_MODERATION,
	};
}

function fetchingEventForModerationSuccess(payload) {
	return {
		type: types.FETCH_EVENT_FOR_MODERATION_SUCCESS,
		payload,
	};
}

function fetchingEventForModerationFailed() {
	return {
		type: types.FETCH_EVENT_FOR_MODERATION_FAILED,
	};
}

function fetchingUserForJoinRide() {
	return {
		type: types.FETCH_USER_TO_JOIN_EVENT,
	};
}

function fetchingUserForJoinRideSuccess(payload) {
	return {
		type: types.FETCH_USER_TO_JOIN_EVENT_SUCCESS,
		payload,
	};
}

function fetchingUserForJoinRideFailed() {
	return {
		type: types.FETCH_USER_TO_JOIN_EVENT_FAILED,
	};
}

function moderationForRideUser() {
	return {
		type: types.MODERATION_FOR_USER_EVENT,
	};
}

function moderationForRideUserSuccess(payload) {
	return {
		type: types.MODERATION_FOR_USER_EVENT_SUCCESS,
		payload,
	};
}

function moderationForRideUserFailed() {
	return {
		type: types.MODERATION_FOR_USER_EVENT_FAILED,
	};
}

function fetchingAllUser() {
	return {
		type: types.FETCH_ALL_USERS,
	};
}

function fetchingAllUserSuccess(payload) {
	return {
		type: types.FETCH_ALL_USERS_SUCCESS,
		payload,
	};
}

function fetchingAllUserFailed() {
	return {
		type: types.FETCH_ALL_USERS_FAILED,
	};
}

function joiningNewUser() {
	return {
		type: types.JOIN_NEW_USER,
	};
}

function joiningNewUserSuccess(payload) {
	return {
		type: types.JOIN_NEW_USER_SUCCESS,
		payload,
	};
}

function joiningNewUserFailed() {
	return {
		type: types.JOIN_NEW_USER_FAILED,
	};
}

function fetchingImagesForModeration() {
	return {
		type: types.FETCH_IMAGES_FOR_MODERATION,
	};
}

function fetchingImagesForModerationSuccess(payload) {
	return {
		type: types.FETCH_IMAGES_FOR_MODERATION_SUCCESS,
		payload,
	};
}

function fetchingImagesForModerationFailed() {
	return {
		type: types.FETCH_IMAGES_FOR_MODERATION_FAILED,
	};
}

function moderatingImages() {
	return {
		type: types.MODERATED_IMAGES,
	};
}

function moderatingImagesSuccess(payload) {
	return {
		type: types.MODERATED_IMAGES_SUCCESS,
		payload,
	};
}

function updatingEventByAdmin() {
	return {
		type: types.UPDATE_EVENT_BY_ADMIN,
	};
}

function updatingEventByAdminSuccess(payload) {
	return {
		type: types.UPDATE_EVENT_BY_ADMIN_SUCCESS,
		payload,
	};
}

function updatingEventByAdminFailed() {
	return {
		type: types.UPDATE_EVENT_BY_ADMIN_FAILED,
	};
}

function moderatingImagesFailed() {
	return {
		type: types.MODERATED_IMAGES_FAILED,
	};
}
function clearingPreviousReducer() {
	return {
		type: types.CLEAR_PREVIOUS_REDUCERS,
	};
}

//****** clearPreviousReducer  ********//

export const clearPreviousReducer = (payload) => async (dispatch) => {
	dispatch(clearingPreviousReducer());
};
//****** fetchAllEvent  ********//

export const fetchAllEvent = (payload) => async (dispatch, getState, api) => {
	dispatch(fetchingAllEvents());
	try {
		let response = await api.get(API.createEvent);
		if (response.data.code === 200) {
			dispatch(fetchingAllEventsSuccess(response.data.data));
		} else {
			dispatch(fetchingAllEventsFailed());
		}
	} catch (error) {
		dispatch(fetchingAllEventsFailed(errorMessage));
	}
};

//****** fetchSingleEvent  ********//

export const fetchSingleEvent = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(fetchingSingleEvent());
	try {
		let response = await api.get(
			`${API.fetchSingleEvent}?eventId=${payload}`
		);
		if (response.data.code === 200) {
			dispatch(fetchingSingleEventSuccess(response.data.data));
		} else {
			dispatch(fetchingSingleEventFailed());
		}
	} catch (error) {
		dispatch(fetchingSingleEventFailed(errorMessage));
	}
};

//****** Fetching Country  ********//

export const fetchEventCountry = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(fetchingCountry());
	try {
		let response = await api.get(API.fetchEventCountry);
		if (response.data.code === 200) {
			dispatch(fetchingCountrySuccess(response.data.data));
		} else {
			dispatch(fetchingCountryFailed());
		}
	} catch (error) {
		dispatch(fetchingCountryFailed(errorMessage));
	}
};

//****** Fetching State  ********//

export const fetchEventState = (payload) => async (dispatch, getState, api) => {
	dispatch(fetchingState());
	try {
		let response = await api.get(
			`${API.fetchEventState}?country=${payload}`
		);

		if (response.data.code === 200) {
			dispatch(fetchingStateSuccess(response.data.data));
		} else {
			dispatch(fetchingStateFailed());
		}
	} catch (error) {
		dispatch(fetchingStateFailed(errorMessage));
	}
};

//****** Fetching City  ********//

export const fetchEventCity = (payload) => async (dispatch, getState, api) => {
	dispatch(fetchingCity());
	try {
		let response = await api.get(
			`${API.fetchEventCity}?country=${payload.countryCode}&state=${payload.state}`
		);

		if (response.data.code === 200) {
			dispatch(fetchingCitySuccess(response.data.data));
		} else {
			dispatch(fetchingCityFailed());
		}
	} catch (error) {
		dispatch(fetchingCityFailed(errorMessage));
	}
};

//****** createEvent  ********//

export const createEvent = (payload) => async (dispatch, getState, api) => {
	dispatch(creatingEvent());

	console.log(payload);

	try {
		let response = await api.post(API.createEvent, payload);
		if (response.data.code === 200) {
			dispatch(creatingEventSuccess(response.data.data));
			history.push("/event/list");
			toast.error(response.data.message);
		} else {
			dispatch(creatingEventFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(creatingEventFailed(errorMessage));
	}
};

//****** updateEvent  ********//

export const updateEvent = (payload) => async (dispatch, getState, api) => {
	dispatch(updatingEvent());

	try {
		console.log({ payload });
		let response = await api.post(API.createEvent, payload);
		if (response.data.code === 200) {
			dispatch(updatingEventSuccess(response.data.data));
			history.push("/event/list");
			toast.error(response.data.message);
		} else {
			dispatch(updatingEventFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(updatingEventFailed(errorMessage));
	}
};

//****** deleteEvent  ********//

export const deleteEvent = (payload) => async (dispatch, getState, api) => {
	dispatch(deletingEvent());
	try {
		let response = await api.post(API.createEvent, payload);
		if (response.data.code === 200) {
			dispatch(deletingEventSuccess(response.data.data));
			toast.error(response.data.message);
		} else {
			dispatch(deletingEventFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(deletingEventFailed(errorMessage));
	}
};

//****** Fetch Event for Moderation ********//

export const fetchEventForModeration = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(fetchingEventForModeration());
	try {
		let response = await api.get(
			`${API.fetchEventForModeration}?status=${payload}`
		);
		if (response.data.code === 200) {
			dispatch(fetchingEventForModerationSuccess(response.data.data));
		} else {
			dispatch(fetchingEventForModerationFailed());
		}
	} catch (error) {
		dispatch(fetchingEventForModerationFailed(errorMessage));
	}
};

//****** Moderation of Event ********//

export const moderateEvent = (payload, status) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(moderatingEvent());
	try {
		let response = await api.post(API.moderateEvent, payload);
		if (response.data.code === 200) {
			dispatch(moderatingEventSuccess(response.data.data));
			dispatch(fetchEventForModeration(status));
			history.push("/event/moderation");
			toast.error(response.data.message);
		} else {
			dispatch(moderatingEventFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(moderatingEventFailed(errorMessage));
	}
};

//** Moderate event gallery */

export const moderateEventGallery = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(moderatingEventGallery());
	try {
		let response = await api.post(API.moderateEventGallery, payload);
		if (response.data.code === 200) {
			dispatch(moderatingEventGallerySuccess(response.data.data));
			toast.error(response.data.message);
		} else {
			dispatch(moderatingEventGalleryFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(moderatingEventFailed(errorMessage));
	}
};

//****** Fetch User for Join Event  ********//

export const fetchUserForJoinRide = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(fetchingUserForJoinRide());
	try {
		let response = await api.get(
			`${API.fetchUserForJoinRide}?activityId=${payload.id}&moderationStatus=${payload.status}`
		);
		if (response.data.code === 200) {
			dispatch(fetchingUserForJoinRideSuccess(response.data.data));
		} else {
			dispatch(fetchingUserForJoinRideFailed());
		}
	} catch (error) {
		dispatch(fetchingUserForJoinRideFailed(errorMessage));
	}
};

//****** Fetching User  ********//

export const fetchAllUser = (payload) => async (dispatch, getState, api) => {
	dispatch(fetchingAllUser());
	try {
		let response = await api.get(
			`${API.fetchAllUser}?phone=${payload.mobile}&email=${payload.email}`
		);

		if (response.data.code === 200) {
			dispatch(fetchingAllUserSuccess(response.data.data));
		} else {
			dispatch(fetchingAllUserFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(fetchingAllUserFailed(errorMessage));
	}
};

//****** Fetch User for Join Event  ********//

export const moderateUserForRide = (payload) => async (
	dispatch,
	getState,
	api
) => {
	let data = {
		status: "PENDING",
		id: payload.rideId,
	};
	dispatch(moderationForRideUser());
	try {
		let response = await api.post(API.fetchUserForJoinRide, payload);
		if (response.data.code === 200) {
			dispatch(moderationForRideUserSuccess(response.data.data));
			dispatch(fetchUserForJoinRide(data));
			dispatch(clearPreviousReducer());
			toast.error(response.data.message);
		} else {
			dispatch(moderationForRideUserFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(moderationForRideUserFailed(errorMessage));
	}
};

//****** Join New User  ********//

export const joinNewUser = (payload) => async (dispatch, getState, api) => {
	dispatch(joiningNewUser());
	try {
		let response = await api.post(API.joinNewUser, payload);
		if (response.data.code === 200) {
			dispatch(joiningNewUserSuccess(response.data.data));
			toast.error(response.data.message);
			dispatch(clearPreviousReducer());
		} else {
			dispatch(joiningNewUserFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(joiningNewUserFailed(errorMessage));
	}
};

//****** Fetch Image For Ride   ********//

export const fetchImagesForModeration = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(fetchingImagesForModeration());
	try {
		let response = await api.get(
			`${API.fetchImagesForModeration}?status=${payload.status}`
		);
		if (response.data.code === 200) {
			dispatch(fetchingImagesForModerationSuccess(response.data.data));
		} else {
			dispatch(fetchingImagesForModerationFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(fetchingImagesForModerationFailed(errorMessage));
	}
};

//******  Moderate Image ********//

export const moderateRideImages = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(moderatingImages());
	try {
		let response = await api.post(API.moderateRideImages, payload);

		if (response.data.code === 200) {
			dispatch(moderatingImagesSuccess(response.data.data));
			toast.error(response.data.message);
		} else {
			dispatch(moderatingImagesFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(moderatingImagesFailed(errorMessage));
	}
};

//****** adminUpdateEvent  ********//

export const updateEventByAdmin = (payload) => async (
	dispatch,
	getState,
	api
) => {
	dispatch(updatingEventByAdmin());

	try {
		let response = await api.put(API.updateEventByAdmin, payload);
		if (response.data.code === 200) {
			dispatch(updatingEventByAdminSuccess(response.data.data));
			history.push("/event/moderation");
			toast.error(response.data.message);
		} else {
			dispatch(updatingEventByAdminFailed());
			toast.error(response.data.message);
		}
	} catch (error) {
		dispatch(updatingEventByAdminFailed(errorMessage));
	}
};
